export default __webpack_public_path__ + "static/media/3 raw.d6fbf518.mp3";